import PageShell from "../components/PageShell";
import { insights } from "../data/siteData";

export default function InsightsPage() {
  return (
    <PageShell pageClass="page-insights">
      <div className="container narrow article-layout">
        <h1 className="text-center">Insights</h1>
        <p>
          When I started my design journey, I did not know freelancing would
          teach me as much as it did. Working with clients across different
          industries has been both challenging and rewarding. Here are five
          lessons that shaped me as a designer and creative professional.
        </p>

        {insights.map((item) => (
          <section key={item.title} className="insight-block">
            <h2>{item.title}</h2>
            <p>{item.body}</p>
          </section>
        ))}

        <p className="closing">
          Freelancing is not just about earning. It is about learning. Each
          client, each challenge, and each project adds a new layer to the
          creative journey.
        </p>
      </div>
    </PageShell>
  );
}
